import { useEffect, useState } from 'react'
import { api } from './api.js'

// Suivi sans compte : un numéro, un code. C'est tout ce qu'on demande à
// quelqu'un qui veut savoir où en est son dossier.
export default function Suivi() {
  const params = new URLSearchParams(window.location.search)
  const [numero, setNumero] = useState(params.get('n') || '')
  const [code, setCode] = useState(params.get('c') || '')
  const [dossier, setDossier] = useState(null)
  const [erreur, setErreur] = useState('')
  const [reponse, setReponse] = useState('')

  async function chercher(e) {
    e?.preventDefault()
    setErreur('')
    try {
      setDossier(await api.follow(numero.trim(), code.trim().toUpperCase()))
    } catch (err) {
      setDossier(null)
      setErreur(err.message)
    }
  }

  useEffect(() => { if (numero && code) chercher() }, [])   // eslint-disable-line

  async function repondre() {
    try {
      await api.answer(numero, code, { text: reponse })
      setReponse('')
      chercher()
    } catch (err) { setErreur(err.message) }
  }

  return (
    <div className="wrap">
      <h1>Suivre ma demande</h1>
      <form className="suivi" onSubmit={chercher}>
        <div className="champ">
          <label htmlFor="n">Numéro de dossier</label>
          <input id="n" value={numero} onChange={(e) => setNumero(e.target.value)} placeholder="26-00042" />
        </div>
        <div className="champ">
          <label htmlFor="c">Code de suivi</label>
          <input id="c" value={code} onChange={(e) => setCode(e.target.value)} placeholder="ABCD2345" />
        </div>
        <button className="btn pri">Afficher</button>
      </form>

      {erreur && <p className="erreur" role="alert">{erreur}</p>}

      {dossier && (
        <article className="dossier">
          <h2>{dossier.title}</h2>
          <p className="etat">{dossier.status}</p>

          {dossier.awaiting && (
            <section className="attente">
              <h3>Le service attend votre réponse</h3>
              <p>{dossier.awaiting.question}</p>
              <label htmlFor="rep">Votre réponse</label>
              <textarea id="rep" rows={4} value={reponse} onChange={(e) => setReponse(e.target.value)} />
              <button className="btn pri" onClick={repondre} disabled={!reponse.trim()}>
                Envoyer ma réponse
              </button>
            </section>
          )}

          <h3>Avancement</h3>
          <ol className="journal">
            {dossier.events.map((e, i) => (
              <li key={i}>
                <time dateTime={e.at}>{new Date(e.at).toLocaleDateString('fr-FR')}</time>
                <strong>{e.title}</strong>
                {e.body && <p>{e.body}</p>}
              </li>
            ))}
          </ol>
        </article>
      )}
    </div>
  )
}
